const productsData = [
    {
        "id": 1,
        "storeId": 1,
        "name": "Shrimp Tempura",
        "description": "Fresh shrimp battered and deep fried until golden brown",
        "price": 10.95
    },
    {
        "id": 2,
        "storeId": 1,
        "name": "Shrimp with Snow Peas and Cashew",
        "description": "A delicious combination of fresh shrimp, snow peas, and cashew",
        "price": 12.50
    },
    {
        "id": 3,
        "storeId": 1,
        "name": "Special Deep-Fried Fish",
        "description": "Tilapia fish deep fried until flaky and tender",
        "price": 12.95
    },
    {
        "id": 4,
        "storeId": 2,
        "name": "BBQ Pork Egg Foo Yung",
        "description": "Chinese omelette filled with barbequed pork",
        "price": 10.95
    },
    {
        "id": 5,
        "storeId": 2,
        "name": "Beef Egg Foo Yung",
        "description": "A Chinese omelette mixed with beef",
        "price": 10.95
    },
    {
        "id": 6,
        "storeId": 2,
        "name": "Mushroom Egg Foo Yung",
        "description": "A Chinese omelette mixed with sliced mushrooms",
        "price": 9.95
    },
    {
        "id": 7,
        "storeId": 3,
        "name": "BBQ Pork, Chicken, or Mushroom Chop Suey",
        "description": "",
        "price": 8.75
    },
    {
        "id": 8,
        "storeId": 3,
        "name": "Deluxe Chop Suey",
        "description": "Shrimp, barbeque pork, and chicken",
        "price": 9.95
    },
    {
        "id": 9,
        "storeId": 3,
        "name": "Plain Fried Rice",
        "description": "",
        "price": 7.50
    },
    {
        "id": 10,
        "storeId": 4,
        "name": "10\" Small Greek Pizza",
        "description": "Green or black olives, onions, tomato, and feta cheese",
        "price": 8.99
    },
    {
        "id": 11,
        "storeId": 4,
        "name": "12\" Medium Deluxe Pizza",
        "description": "Pepperoni, bacon, mushrooms, onions, and green peppers",
        "price": 12.99
    },
    {
        "id": 12,
        "storeId": 4,
        "name": "Pizza and Wings Special",
        "description": "One twelve-inch medium pizza with two toppings and twelve chicken wings",
        "price": 16.99
    },
    {
        "id": 13,
        "storeId": 5,
        "name": "10' Garden Fresh Pizza",
        "description": "Green peppers, onions, mushrooms, black olives, and Roma tomatoes",
        "price": 14.00
    },
    {
        "id": 14,
        "storeId": 5,
        "name": "12' Tuscan Six-Cheese Pizza",
        "description": "An authentic blend of Parmesan, Romano, Asiago, fontina, provolone, and 100% real cheese made from mozzarella",
        "price": 19.00
    },
    {
        "id": 15,
        "storeId": 5,
        "name": "14' Hawaiian Chicken Pizza",
        "description": "A sweet and savory combination of juicy pineapple and grilled chicken",
        "price": 22.00
    },
    {
        "id": 16,
        "storeId": 6,
        "name": "Medium One-Topping Pie",
        "description": "A 12-inch, medium pizza made of famous, fresh, house-made dough, cooked with one topping of your choice",
        "price": 15.00
    },
    {
        "id": 17,
        "storeId": 6,
        "name": "X-Large One-Topping Pie",
        "description": "An extra large, 16-inch pizza made of famous, fresh, house-made dough, cooked with one topping of your choice",
        "price": 23.00
    },
    {
        "id": 18,
        "storeId": 6,
        "name": "Medium BBQ Pulled Pork Pie",
        "description": "A 12-inch pizza made of famous, fresh, and house-made dough, topped with Caribbean jerk chicken, pineapple, onions, feta, and mozzarella cheese",
        "price": 19.00
    },
    {
        "id": 19,
        "storeId": 7,
        "name": "Pork Spring Roll (6 pcs) - Cha Gio (6 Cuon)",
        "description": "Served with fish sauce. One order comes with six spring rolls",
        "price": 7.50
    },
    {
        "id": 20,
        "storeId": 7,
        "name": "Butterfly Shrimp - Tom Chien",
        "description": "Served with sweet chilli sauce",
        "price": 10.50
    },
    {
        "id": 21,
        "storeId": 7,
        "name": "Deluxe Wonton Soup (15 pcs) - Hoanh Thanh Sup Thap Cam (15)",
        "description": "One order comes with fifteen wontons",
        "price": 10.35
    },
    {
        "id": 22,
        "storeId": 8,
        "name": "Grilled Pork Skewers (2 pcs)",
        "description": "House-marinated ground pork skewers with roasted peanuts and bacon. One order comes with two skewers",
        "price": 5.75
    },
    {
        "id": 23,
        "storeId": 8,
        "name": "Chicken Wang-Yo!",
        "description": "Stuffed minced chicken, carrot, green onions, mushrooms, black pepper, and bean thread noodles",
        "price": 9.95
    },
    {
        "id": 24,
        "storeId": 8,
        "name": "Beef Stew",
        "description": "Beef flank, carrot, jumbo onion, scallions, cilantro, mint, and Thai basil. Served with a side of baguette and broth",
        "price": 8.75
    },
    {
        "id": 25,
        "storeId": 9,
        "name": "Tripe and Flank Pho - Nam Long",
        "description": "A tasty blend of beef tripe and flank served in a steaming-hot rice noodle soup",
        "price": 8.99
    },
    {
        "id": 26,
        "storeId": 9,
        "name": "Charbroiled Pork - Thit Nuong",
        "description": "Tender charbroiled pork served atop a bed of vermicelli noodles with iceberg lettuce, bean sprouts, cucumbers, pickled carrot, and radish",
        "price": 9.99
    },
    {
        "id": 27,
        "storeId": 9,
        "name": "Charbroiled Beef - Bo Nuong",
        "description": "Savoury charbroiled beef served atop a bed of vermicelli noodles with iceberg lettuce, bean sprouts, cucumbers, pickled carrot, and radish",
        "price": 10.49
    },
    {
        "id": 28,
        "storeId": 10,
        "name": "Assorted Sashimi",
        "description": "Fresh assorted sashimi, hand-picked and thinly sliced by the chef",
        "price": 20.00
    },
    {
        "id": 29,
        "storeId": 10,
        "name": "Sake (Salmon) Sashimi",
        "description": "Thinly sliced raw salmon served on its own",
        "price": 9.00
    },
    {
        "id": 30,
        "storeId": 10,
        "name": "Red Tuna Sashimi",
        "description": "Thinly sliced red tuna, served without rice",
        "price": 13.00
    },
    {
        "id": 31,
        "storeId": 11,
        "name": "Ebi - Nigiri (1 pc)",
        "description": "Steamed shrimp, served on a small bed of pressed sushi rice. One order comes with one piece",
        "price": 2.50
    },
    {
        "id": 32,
        "storeId": 11,
        "name": "Hamachi - Nigiri (1 pc)",
        "description": "Thinly sliced yellowtail served on a small bed of pressed sushi rice. One order comes with one piece",
        "price": 3.50
    },
    {
        "id": 33,
        "storeId": 11,
        "name": "Ika - Nigiri (1 pc)",
        "description": "Thin-sliced squid served on a small bed of pressed sushi rice. One order comes with one piece",
        "price": 2.50
    },
    {
        "id": 34,
        "storeId": 12,
        "name": "Salmon Sushi (2 pcs)",
        "description": "Fresh, raw salmon wrapped with rice and seaweed. One order comes with two pieces",
        "price": 5.45
    },
    {
        "id": 35,
        "storeId": 12,
        "name": "Masago Sushi (2 pcs)",
        "description": "Red caviar wrapped with rice and seaweed. One order comes with two pieces",
        "price": 4.75
    },
    {
        "id": 36,
        "storeId": 12,
        "name": "Amaebi Sushi (2 pcs)",
        "description": "Sweet shrimp wrapped in rice and seaweed. One order comes with two pieces",
        "price": 5.75
    }
];

export function getProductsByStoreId(storeId) {
    return productsData.filter(product => product.storeId.toString() === storeId);
};

export default productsData;


// WEBPACK FOOTER //
// ./src/data/Product.js